'use client';

import Link from 'next/link';
import { useCart } from '@/components/CartProvider';
import { supabase } from '@/lib/supabase';

function getSupabaseImageUrl(sku) {
    const { data } = supabase.storage.from('product-images').getPublicUrl(`image/${sku}.png`);
    return data.publicUrl;
}

export default function CartPage() {
    const { cartItems, updateQuantity, removeFromCart, cartTotal, isMounted } = useCart();

    if (!isMounted) {
        return <div className="section container text-center">載入中...</div>;
    }

    if (cartItems.length === 0) {
        return (
            <div className="section animate-fade-in text-center" style={{ minHeight: '50vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>您的購物車是空的</h1>
                <p style={{ color: 'var(--muted-foreground)', marginBottom: '2rem' }}>看起來您還沒有加入任何商品。</p>
                <Link href="/products" className="btn btn-primary">
                    開始購物
                </Link>
            </div>
        );
    }

    return (
        <div className="section animate-fade-in">
            <div className="container" style={{ maxWidth: '1000px' }}>
                <h1 style={{ fontSize: '2.5rem', marginBottom: '2rem', borderBottom: '1px solid var(--border)', paddingBottom: '1.5rem', textAlign: 'center', fontWeight: '700' }}>
                    購物車
                </h1>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {cartItems.map(item => (
                            <div key={item.sku} style={{
                                display: 'grid', gridTemplateColumns: '80px 1fr auto auto', gap: '1.5rem',
                                alignItems: 'center', padding: '1rem', borderBottom: '1px solid var(--border)',
                                background: 'transparent'
                            }}>
                                <img
                                    src={getSupabaseImageUrl(item.sku)}
                                    alt={item.chinese_name || item.name}
                                    style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '0.5rem', background: 'white' }}
                                    onError={(e) => { e.target.src = '/placeholder.png'; e.target.style.objectFit = 'contain'; e.target.style.padding = '0.5rem'; }}
                                />

                                <div>
                                    <Link href={`/products/${item.sku}`} className="product-title" style={{ fontSize: '1.125rem', marginBottom: '0.25rem', display: 'inline-block' }}>
                                        {item.chinese_name || item.name}
                                    </Link>
                                    <div style={{ fontSize: '0.875rem', color: 'var(--muted-foreground)' }}>SKU: {item.sku}</div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <button onClick={() => updateQuantity(item.sku, item.quantity - 1)} className="btn btn-secondary" style={{ padding: '0.25rem 0.75rem' }}>-</button>
                                    <span style={{ minWidth: '2rem', textAlign: 'center', fontWeight: '500' }}>{item.quantity}</span>
                                    <button onClick={() => updateQuantity(item.sku, item.quantity + 1)} className="btn btn-secondary" style={{ padding: '0.25rem 0.75rem' }}>+</button>
                                </div>

                                <div style={{ textAlign: 'right', minWidth: '100px' }}>
                                    <div style={{ fontWeight: '700', fontSize: '1.125rem', color: 'var(--primary)' }}>
                                        NT$ {((item.sell_price * item.quantity)).toLocaleString()}
                                    </div>
                                    <button onClick={() => removeFromCart(item.sku)} style={{ color: 'var(--muted-foreground)', fontSize: '0.875rem', marginTop: '0.5rem', textDecoration: 'underline' }}>
                                        移除
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div style={{
                        background: 'var(--secondary)',
                        padding: '2rem',
                        borderRadius: 'var(--radius)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        gap: '1.5rem'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', maxWidth: '300px', fontSize: '1.25rem', fontWeight: 'bold' }}>
                            <span>小計:</span>
                            <span style={{ color: 'var(--primary)' }}>NT$ {(cartTotal).toLocaleString()}</span>
                        </div>
                        <p style={{ fontSize: '0.875rem', color: 'var(--muted-foreground)' }}>
                            運費與稅金將於結帳時計算
                        </p>
                        <Link href="/checkout" className="btn btn-primary" style={{ padding: '1rem 3rem', fontSize: '1.125rem', width: '100%', maxWidth: '300px' }}>
                            前往結帳
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    );
}
